module.exports = __webpack_public_path__ + "static/media/ballast-bag.c7c18b24.svg";